import React from "react";
import clearLogo from "@/images/clear_logo.svg";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import useTranslation from "@hooks/use_translation";
import { cn } from "@/lib/utils";

type Props = {
  className?: string;
  tooltip?: string | null;
};

const ClearVerifiedBadge: React.FC<Props> = ({ className = "", tooltip }) => {
  const { t } = useTranslation("clear_verification");
  const tooltipLabel = tooltip ?? t("badge.verified");

  if (!tooltipLabel) return null;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className={cn("h-5 w-5", className)} aria-label={tooltipLabel} title={tooltipLabel}>
          <img src={clearLogo} alt="CLEAR" />
        </span>
      </TooltipTrigger>
      <TooltipContent>{tooltipLabel}</TooltipContent>
    </Tooltip>
  );
};

export default ClearVerifiedBadge;
